// extracted by css-extract-rspack-plugin
export default {"body":"RHnXq_Hmubg_1aIy","formSection":"JZv_486JJ0YwtgfS","reasonLabel":"G40Sw6NaoQs85YFT","stratifiedSamplingAlert":"EbJSoEJag4VozC0q"};